module.exports = __webpack_public_path__ + "img/corner-down-left.b88b86bb.svg";